import axios from 'axios'
import config from '../config'
import { getDoctorToken } from '../utils'

const getTestCategoriesApi = async (params) => {
    const response = await axios({
        url: `${config.api.base_url}test-master/fetch-categories`,
        method: "get",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${getDoctorToken()}`
        }
    })

    return response

}

export default getTestCategoriesApi